export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  rounded?: boolean;
}

export function Skeleton({ width = '100%', height = 16, rounded = true }: SkeletonProps) {
  return (
    <div
      className="skeleton"
      style={{
        width,
        height,
        borderRadius: rounded ? 4 : 0,
      }}
      aria-hidden="true"
    />
  );
}

export function SkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={24} />
      ))}
    </div>
  );
}
